export const ADD_WAREHOUSE_BILL_CHARGE_REQUEST = 'ADD_WAREHOUSE_BILL_CHARGE_REQUEST';
export const ADD_WAREHOUSE_BILL_CHARGE_SUCCESS = 'ADD_WAREHOUSE_BILL_CHARGE_SUCCESS';
export const ADD_WAREHOUSE_BILL_CHARGE_FAILURE = 'ADD_WAREHOUSE_BILL_CHARGE_FAILURE';

export const ADD_WAREHOUSE_BILL_CHARGE_EXCEL_REQUEST = 'ADD_WAREHOUSE_BILL_CHARGE_EXCEL_REQUEST';
export const ADD_WAREHOUSE_BILL_CHARGE_EXCEL_SUCCESS = 'ADD_WAREHOUSE_BILL_CHARGE_EXCEL_SUCCESS';
export const ADD_WAREHOUSE_BILL_CHARGE_EXCEL_FAILURE = 'ADD_WAREHOUSE_BILL_CHARGE_EXCEL_FAILURE';

export const SEARCH_WAREHOUSE_BILL_REQUEST = 'SEARCH_WAREHOUSE_BILL_REQUEST';
export const SEARCH_WAREHOUSE_BILL_SUCCESS = 'SEARCH_WAREHOUSE_BILL_SUCCESS';
export const SEARCH_WAREHOUSE_BILL_FAILURE = 'SEARCH_WAREHOUSE_BILL_FAILURE';

export const FETCH_DATA_REQUEST = 'FETCH_DATA_REQUEST';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';

export const DELETE_WAREHOUSE_REQUEST = 'DELETE_WAREHOUSE_REQUEST';
export const DELETE_WAREHOUSE_SUCCESS = 'DELETE_WAREHOUSE_SUCCESS';
export const DELETE_WAREHOUSE_FAILURE = 'DELETE_WAREHOUSE_FAILURE';

export const FETCH_BILL_NUMBER_REQUEST = 'FETCH_BILL_NUMBER_REQUEST';
export const FETCH_BILL_NUMBER_SUCCESS = 'FETCH_BILL_NUMBER_SUCCESS';
export const FETCH_BILL_NUMBER_FAILURE = 'FETCH_BILL_NUMBER_FAILURE';